// extracted by mini-css-extract-plugin
module.exports = {"kind":"Kind_kind__eswfh","subtype":"Kind_subtype__NfJKq","type":"Kind_type__FX7CC"};